<template>
  <div
    id="app"
    class="relative vh-100 w-100 dark-gray"
    :class="{
      'brand-lh': brand === 'lh',
      'brand-lq': brand === 'lq'
    }"
  >
    <Logo
      v-if="brand && $route.path !== '/'"
      :brand="brand"
    />
    <transition
      name="fade"
      mode="out-in"
    >
      <router-view />
    </transition>
    <transition
      enter-active-class="fade-in-bottom"
      leave-to-class="fade"
    >
      <NavPrimary v-if="showNav" />
    </transition>
  </div>
</template>
<script>
import Logo from '@/components/Logo.vue'
import NavPrimary from '@/components/NavPrimary.vue'

export default {
  name: 'App',
  components: {
    Logo,
    NavPrimary
  },
  computed: {
    brand () {
      if (this.$store.state.content && this.$route.params.id && this.$store.getters.getDevelopment('developments/' + this.$route.params.id)) {
        const development = this.$store.getters.getDevelopment('developments/' + this.$route.params.id)
        return development.brand
      } else {
        return 'lh'
      }
    },
    showNav () {
      const hidePrimaryNav = [
        'developments',
        'property-intro',
        'property-floorplans',
        'property-specifications',
        'property-purchase-options'
      ]
      if (hidePrimaryNav.includes(this.$route.name)) {
        return false
      } else {
        return true
      }
    }
  },
  created () {
    this.$store.dispatch('init')
  },
  mounted () {
    if (window.location.hostname !== 'localhost') {
      if (window.localStorage.getItem('laurus-homes-interactive')) {
        const store = JSON.parse(window.localStorage.getItem('laurus-homes-interactive'))
        if (store.version === this.$store.state.version) {
          this.$store.replaceState(JSON.parse(window.localStorage.getItem('laurus-homes-interactive')))
        }
      }
      this.$store.subscribe((mutation, state) => {
        window.localStorage.setItem('laurus-homes-interactive', JSON.stringify(state))
      })
    }

    if (this.$route.query.d) {
      this.$store.commit('setDefault', '/developments/' + this.$route.query.d)
    }

    let self = this

    // Refresh content from API every 15 minutes
    setInterval(() => {
      self.$store.dispatch('getContent')
    }, 60 * 5 * 1000)

    // Global Inactivity Timer
    let timeout

    function resetTimer () {
      const globalTimer = 300

      clearTimeout(timeout)
      timeout = setTimeout(() => {
        if (self.$router.path !== self.$store.state.default) {
          self.$router.push(self.$store.state.default)
        }
      }, globalTimer * 1000)
    }
    resetTimer()

    document.addEventListener('click', resetTimer)
    document.addEventListener('mousemove', resetTimer)
    document.addEventListener('mousedown', resetTimer)
    document.addEventListener('touchstart', resetTimer)
    document.addEventListener('scroll', resetTimer)
    document.addEventListener('keypress', resetTimer)
    document.addEventListener('load', resetTimer)
  }
}
</script>
<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Montserrat:200,300,400,600,700,&display=swap');

html {
  font-size: 16px;
  @media (min-width: 2000px) {
    font-size: 20px;
  }
}
* {
  -webkit-tap-highlight-color: transparent;
}
*:focus { outline: none !important; }
#app {
  font-family: 'Montserrat', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.green {color: #28A745 !important}
.bg-green {background-color: #28A745 !important}
.b--green {border-color: #28A745 !important}

.purple {color: #662483 !important}
.bg-purple {background-color: #662483 !important}
.b--purple {border-color: #662483 !important}

.light {color: #F8F9FA !important}
.bg-light {background-color: #F8F9FA !important}
.b--light {border-color: #F8F9FA !important}

.purple-inactive {color: #AE8DBC !important}
.bg-purple-inactive {background-color: #AE8DBC !important}
.b--purple-inactive {border-color: #AE8DBC !important}

.purple-deep {color: #280740 !important}
.bg-purple-deep {background-color: #280740 !important}
.b--purple-deep {border-color: #280740  !important}

.light-purple {color: lighten(#652d90, 50%) !important}
.bg-light-purple {background-color: lighten(#652d90, 50%) !important}
.b--light-purple {border-color: lighten(#652d90, 50%) !important}

.yellow {color: #fae229;}
.bg-yellow {background-color: #fae229;}
.b--yellow {border-color: #fae229;}

.tracked-small {letter-spacing: .075em}

.bottom-50 {bottom: 50%}
.top-50 {top: 50%}
.left-50 {left: 50%}

.absolute--center,
.fixed--center {
  left: 50%;
  top: 50%;
}
.relative--fill,
.fixed--fill {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.f8 {
  font-size: .65rem;
}
.transform--center {
  transform: translateX(-50%) translateY(-50%)
}

.w-15 {
  width: 15%;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .35s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.slider-content::-webkit-scrollbar, .back-card-content::-webkit-scrollbar  {
  width: 5px;
  overflow: visible;
  display: block !important;
}
.slider-content::-webkit-scrollbar-track{
  background-color: lightgrey;
  border-radius: 10px;
}
.slider-content::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: rgba(94, 44, 165, 0.7);
}
.slider-content::-webkit-scrollbar-thumb:window-inactive {
  background-color: rgba(94, 44, 165, 0.7);
}
.brand-lq {
  .slider-content::-webkit-scrollbar-thumb:window-inactive {
    background-color: #333;
  }
  .slider-content::-webkit-scrollbar-thumb {
    background-color: #333;
  }
}

.back-card-content::-webkit-scrollbar-track {
  background: #999;
  overflow: visible;
}
::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.5);
  width: 1px;
}
::-webkit-scrollbar-thumb:vertical {
  height: 2rem;
}
::-webkit-scrollbar-thumb:window-inactive {
  background: rgba(255, 255, 255, 0.5);
}

.fade-in-bottom {
  animation: fade-in-bottom 0.6s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
}
@keyframes fade-in-bottom {
  0% {
    transform: translateY(50px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
